module.exports = __webpack_public_path__ + "static/media/italic.bfc68f59.svg";